import toast from './toast'

const Toast = {}

// 注册Toast
Toast.install = (Vue) => {
  // 生成一个Vue的子类
  const ToastConstructor = Vue.extend(toast)
  // 生成一个该子类的实例
  const instance = new ToastConstructor()
  // 将实例挂载在创建的div上
  // 并将此div加入全局的挂载点内部
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  // 通过Vue的原型注册一个方法
  // 让所有的实例共享这个方法
  const dTime = 1000 
  Vue.prototype.$toast = (msg, duration = 3) => {
    instance.msg = msg
    instance.isShowToast = true
    setTimeout(()=> {
      instance.isShowToast = false
    },dTime * duration)
  }
}
export default Toast



// WEBPACK FOOTER //
// ./src/components/base/toast/index.js